import { simAction, simAdvance, simPress, type AthleteSim } from './sim/athlete.js';
import type { InputBatch } from './protocol.js';
/** Restore the acknowledged server state and replay only inputs still in flight. */
export function reconcile(
  authoritative: AthleteSim,
  batches: InputBatch[],
  until: number,
  active: boolean,
): AthleteSim {
  const sim = structuredClone(authoritative);
  if (!active || sim.done) return sim;
  const clock = sim.kind === 'run' ? sim.state.t : sim.attemptStart + sim.state.t;
  const items = batches
    .flatMap((b) => [
      ...b.presses.map((p) => ({ ...p, kind: 'press' as const })),
      ...b.actions.map((a) => ({ ...a, kind: 'action' as const })),
    ])
    .sort((a, b) => a.t - b.t);
  for (const item of items) {
    const t = Math.max(clock, item.t);
    simAdvance(sim, t);
    if (item.kind === 'press') simPress(sim, item.key, t);
    else simAction(sim, item.down, t);
  }
  simAdvance(sim, Math.max(clock, until));
  return sim;
}
